import { Pipe, PipeTransform } from '@angular/core';
import memoize from '@github/memoize/decorator';
import { StringUtils } from '../utils/string';

@Pipe({ name: 'snakeCaseToDashCase' })
export class SnakeCaseToDashCase implements PipeTransform {
  @memoize()
  public transform(value: string): string {
    if (!value) {
      return '';
    }
    return StringUtils.snakeCaseToDashCase(value);
  }
}
